<template>
  <nav class="vl-dropdown-navigation">
    <!-- Avatar initials -->
    <span class="vlw__header__user-image">{{ userInitials }}</span>

    <!-- Popover -->
    <div
      class="vl-popover vl-dropdown-navigation__popover"
      data-vl-popover
      ref="popover"
    >
      <!-- Username = popover toggle -->
      <button
        class="js-vl-popover__toggle vl-dropdown-navigation__title vl-title vl-title--h6 cursor-pointer"
        aria-expanded="false"
      >
      <span>{{ userName }}</span> 
        
        <i class="vl-vi vl-vi-nav-down ml-1" aria-hidden="true"></i>
      </button>

      <!-- Popover Content -->
      <div
        class="vl-popover__content"
        data-vl-popover-offset-x="11"
        data-vl-popover-offset-y="15"
      >
        <ul class="vl-popover__link-list vl-popover__link-list--bordered">
          <li class="vl-popover__link-list__item">
            <a
              href="#"
              class="vl-link vl-link--block"
              @click.prevent="$emit('open-statistics'); closePopover();"
            >
              <i class="vl-vi vl-vi-business-graph-bar mr-2" aria-hidden="true"></i>
              Mijn Contacten
            </a>
          </li>

          <li class="vl-popover__link-list__item">
            <a
              href="#"
              class="vl-link vl-link--block"
              @click.prevent="$emit('open-settings'); closePopover();"
            >
              <i class="vl-vi vl-vi-user-setting mr-2" aria-hidden="true"></i>
              Instellingen
            </a>
          </li>

          <li class="vl-popover__link-list__item">
            <a
              href="#"
              class="vl-link vl-link--block"
              @click.prevent="$emit('logout'); closePopover();"
            >
              <i class="vl-vi vl-vi-logout mr-2" aria-hidden="true"></i>
              Uitloggen
            </a>
          </li>
        </ul>

        <button
          class="vl-button vl-button--naked-action vl-button--icon-after vl-popover__close-btn"
        >
          <span class="vl-button__label vl-u-hidden vl-u-visible--s">Sluiten</span>
          <i
            class="vl-button__icon vl-button__icon--after vl-vi vl-vi-cross"
            aria-hidden="true"
          ></i>
        </button>
      </div>
    </div>
  </nav>
</template>


<script>
import { mapGetters } from 'vuex';
import bus from '@/utils/bus';

export default {
  name: 'UserDropdown',
  computed: {
    ...mapGetters('authentication', ['userName']),
    userInitials() {
      if (!this.userName) return '';
      const words = this.userName.trim().split(' ').filter(Boolean);
      if (words.length === 1) {
        return words[0][0].toUpperCase();
      }
      return (words[0][0] + words[words.length - 1][0]).toUpperCase();
    }
  },
  methods: {
    closePopover() {
      const toggle = this.$refs.popover.querySelector('.js-vl-popover__toggle');
      if (toggle) {
        toggle.click();
      }
    },
  },
  mounted() {
    if (window.vl && window.vl.popover) {
      window.vl.popover.dress(this.$refs.popover);
    }
  }
};
</script>


<style scoped>
.vlw__header__user-image {
  background: #d8d8d8;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  color: #555;
  text-transform: uppercase;
  overflow: hidden;
}

.vlw__header__user-name {
  line-height: 24px;
  text-transform: uppercase;
  font-weight: 500;
}

.vl-dropdown-navigation {
  border-left: 1px solid #e0e6ed;
  padding-left: 10px;
}

.vl-dropdown-navigation__title:focus,
.vl-dropdown-navigation__title:active {
  outline: none;
  box-shadow: none;
}


/* Quick fix for dropdown title alignment */
.vl-dropdown-navigation__title span {
  position: relative;
  top: -4px;
}

.vl-popover__link-list__item {
  padding-top: 0.85rem;
  padding-bottom: 0.85rem;
  border-bottom: 1px solid #e0e6ed;
}

/* Remove bottom margin for the last item */
.vl-popover__link-list__item:last-child {
  margin-bottom: 0;
  border: 0;
}

.vl-popover .vl-link-list .vl-link,
.vl-popover__link-list .vl-link,
.vl-link-list .vl-link {
  font-size: 1.5rem;
  font-weight: 500;
}

.vl-popover .vl-link-list .vl-link i,
.vl-popover__link-list .vl-link i,
.vl-link-list .vl-link i {
  display: inline-block;
  line-height: 1;
  transform: translateY(2px);
  text-decoration: none;
}

.vl-popover__link-list__item a:hover,
.vl-popover__link-list__item a:focus {
  color: inherit;
  text-decoration: none;
}
</style>